import { getPluralized } from '@shared/helpers';

import type { TTariffState } from './getTariffState';
import type { TFunction } from 'i18next';

export const getRemainingDescription = (
    state: Extract<TTariffState, { type: 'remaining' }>,
    t: TFunction
) => {
    const time = state.hours
        ? getPluralized(state.hours, {
              one: t('common.plurals.hour.one'),
              few: t('common.plurals.hour.few'),
              many: t('common.plurals.hour.many'),
          })
        : getPluralized(state.minutes, {
              one: t('common.plurals.minute.one'),
              few: t('common.plurals.minute.few'),
              many: t('common.plurals.minute.many'),
          });

    if (!state.days) {
        return t('tariff.remaining', { time });
    }

    const days = getPluralized(state.days, {
        one: t('common.plurals.day.one'),
        few: t('common.plurals.day.few'),
        many: t('common.plurals.day.many'),
    });

    return t('tariff.remainingWithDays', { days, time });
};
